import { Row, Col } from 'antd';
import Image from 'next/image';
import styles from './AppImage.module.scss';

const AppImage = ({ content }: any) => {
    return (
        <div className={styles['image-content']}>
            <div className='flex flex-wrap'>
                <div className='md-:w-1/2 w-full'>
                    <img
                        className='w-full'
                        src={content.Image.src}
                        alt={content.ImageTitle.value}
                    />
                </div>
                <Col className='md-:w-1/2 w-full text-justify'>
                    <div dangerouslySetInnerHTML={{ __html: content.ImageTextContent.value }}></div>
                </Col>
            </div>
        </div>
    );
};

export default AppImage;
